import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function SupplierCallout() {
  return <div className="bg-navy-900 border-t border-white/10 py-16 sm:py-20 mt-0" data-id="element-239">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 lg:items-start" data-id="element-241">
          {/* Left Column: Title & Description */}
          <div className="lg:col-span-5" data-id="element-242">
            <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-cg-orange-600 mb-3" data-id="element-243">
              Partner With Us
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4" data-id="element-244">
              Become a Supplier
            </h2>
            <p className="text-sm text-steel-300 leading-relaxed" data-id="element-245">
              Chiltern Global welcomes enquiries from qualified manufacturers
              and distributors supplying operational equipment and specialist
              categories.
            </p>
          </div>

          {/* Right Column: Bullets & CTA */}
          <div className="lg:col-span-7" data-id="element-246">
            <ul className="space-y-4 mb-8" data-id="element-247">
              <li className="flex items-start gap-3" data-id="element-248">
                <span className="w-5 h-px bg-cg-orange-600 mt-2.5 flex-shrink-0" data-id="element-249" />
                <span className="text-sm text-steel-300" data-id="element-250">
                  Product range and category coverage across operational
                  equipment
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-251">
                <span className="w-5 h-px bg-cg-orange-600 mt-2.5 flex-shrink-0" data-id="element-252" />
                <span className="text-sm text-steel-300" data-id="element-253">
                  Regions supplied and typical lead times for procurement cycles
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-254">
                <span className="w-5 h-px bg-cg-orange-600 mt-2.5 flex-shrink-0" data-id="element-255" />
                <span className="text-sm text-steel-300" data-id="element-256">
                  Documentation readiness and quality standards compliance
                </span>
              </li>
            </ul>

            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 border border-steel-400 hover:border-cg-orange-600 text-white hover:text-cg-orange-600 font-bold uppercase tracking-wider text-xs rounded-sm transition-all group" data-id="element-257">
              Supplier Enquiry
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-258" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
}